import { useState, useEffect } from "react";
import {
  Box,
  Button,
  InputAdornment,
  LinearProgress,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, Controller, SubmitHandler } from "react-hook-form";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from '@mui/material/InputBase';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import SupportIcon from '@mui/icons-material/ContactSupport';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Switch from '@mui/material/Switch';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import MenuItem from '@mui/material/MenuItem';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Link from '@mui/material/Link';
import ConfirmDialog, { confirmDialog } from "../components/ConfirmDialog";
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { ICrew } from "../interfaces/ICrew";
import { IUser } from "../interfaces/IUser";
import { ITray } from "../interfaces/ITray";
import { IApplication } from "../interfaces/IApplication";
import { setApplicationValues, setPageTitle } from "../slices/applicationSlice";
import { useAppSelector, useAppDispatch } from "../hooks";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import NextIcon from '@mui/icons-material/NavigateNext';
import BackIcon from '@mui/icons-material/NavigateBefore';
import { IWeek, IWeeks } from "../interfaces/Core/IWeek";
import { ISearchChips } from "../interfaces/Core/ISearchChips";



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));



interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

const resolver: Resolver<IFormInput> = async (values) => {
  return {
    values: values.Name ? values : {},
    errors: !values.Name
      ? {
        Name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

const steps = ['Patching List Management', 'Select Trays'];

type Props = {
  handleSearch: (searchInformation: ISearchChips) => void
}

export default function SearchChips(props: Props) {
  const { handleSearch } = props;
  const dispatch = useAppDispatch();
  const [allRows, setAllRows] = useState<IPatchingRow[]>([]);
  const [rows, setRows] = useState<IPatchingRow[]>([]);
  const [selectedCrew, setSelectedCrew] = useState<ICrew>();
  const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [currentPatchWeek, setCurrentPatchWeek] = useState<IWeek>();
  const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());
  const [patchingWeeks, setPatchingWeeks] = useState<IWeeks>([]);
  const [years, setYears] = useState<number[]>([]);
  const [selectedPatchWeeks, setSelectedPatchWeeks] = useState<IWeeks>([]);

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Patching Lists",
      backgroundPath: "/assets/images/patchingbg.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  useEffect(() => {
    console.log("IN USE EFFECT OF CHANGE VALUE")
    handleSearch({
      year: currentYear,
      weeks: selectedPatchWeeks
    })
  }, [currentYear, selectedPatchWeeks])

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });



  useEffect(() => {
    var years: Array<number> = [];
    for (let index = 0; index < 20; index++) {
      let year = new Date().getFullYear();
      years.push(year + index);
    }

    setYears(years);
  }, []);

  useEffect(() => {
    console.log("Selected Crew Changed");
    if (selectedCrew) {
      var users = selectedCrew.userCrews.map(obj => {
        return obj.user!
      });
      if (users) {
        setSelectedUsers(users);
      }
    }
  }, [selectedCrew])

  useEffect(() => {
    console.log("IN CURRENT USER");
    if (currentUser != undefined) {
      if (selectedUsers) {
        let users = [...selectedUsers, currentUser]
        console.log("USERS", users);
        setSelectedUsers(users);
      }
    }
    setCurrentUser(undefined);
  }, [currentUser])

  useEffect(() => {
    if (currentPatchWeek) {
      if (!selectedPatchWeeks.includes(currentPatchWeek)) {
        var patchWeeks = [...selectedPatchWeeks, currentPatchWeek];
        setSelectedPatchWeeks(patchWeeks);
      }
    }
    setCurrentPatchWeek(undefined);

  }, [currentPatchWeek])

  useEffect(() => {
    if (currentYear) {
      var weeks: IWeeks = [];
      for (let index = 0; index < 52; index++) {
        let pWeek: IWeek = {
          id: index,
          name: `Week ${index}`,
          weekNumber: index
        }
        weeks.push(pWeek);
      }
      setPatchingWeeks(weeks);
    } else {
      setPatchingWeeks([]);
    }

  }, [currentYear])

  useEffect(() => {
    GetPatchingLists();
  }, [selectedPatchWeeks])

  const { register, handleSubmit, control, formState: { errors } } = useForm<IFormInput>({ resolver });


  const handlePatchingDelete = (props: IWeek) => {
    var weeks = selectedPatchWeeks.filter(obj => {
      return obj.id != props.id
    });
    setSelectedPatchWeeks(weeks);
  };

  interface IPatchingRow {
    id: number,
    name: string,
    status: string,
    patchweek: number,
    generation: string
  }





  function GetPatchingLists() {
    var filteredLists = allRows.filter(obj => {
      return selectedPatchWeeks.filter(e => e.id === obj.id).length > 0;
    });
    console.log(selectedPatchWeeks);
    if (selectedPatchWeeks && selectedPatchWeeks.length > 0) {
      console.log("IN HERE");
      setRows(filteredLists);
    } else {
      console.log("IN HERE 2");

      setRows(allRows);
    }
  }


  return (
    <Grid container spacing={0} bgcolor="#101010">
      <Grid item xs={2}>
        <Item sx={{ py: 2, ml: 1 }}>
          <Autocomplete
            value={currentYear}
            options={years}
            getOptionLabel={(option) => option.toString()}
            onChange={(_, data) => {
              setCurrentYear(data!);
            }}
            renderInput={(params) => (
              <TextField {...params} fullWidth variant="outlined" label="Select Year"></TextField>
            )}
          />
        </Item>
      </Grid>
      <Grid item xs={2} >
        <Item sx={{ py: 2, ml: 1 }}>
          <Autocomplete
            value={currentPatchWeek || null}
            options={patchingWeeks}
            getOptionLabel={(option) => option.name}
            onChange={(_, data) => {
              setCurrentPatchWeek(data!);
            }}
            renderInput={(params) => (
              <TextField {...params} fullWidth variant="outlined" label="Weeks"></TextField>
            )}
          />
        </Item>
      </Grid>

      <Grid item xs={8}>
        <Item sx={{ pt: 3 }}>
          <Stack direction="row" spacing={1}>
            {selectedPatchWeeks.map(obj => {
              return <Chip key={obj.id} label={obj.name} color="primary" onDelete={() => handlePatchingDelete(obj)} />
            })}
          </Stack>
        </Item>
      </Grid>
    </Grid>
  );
}
